var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h2',{staticStyle:{"float":"left"}},[_vm._v(" Конференции и вебинары ")]),_c('publications',{attrs:{"type":"seminars","detail-route-name":"SeminarDetail","more-text":"Узнать больше"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }